let isTokenGetter: (() => Promise<string>) | null = null;

export const setIsTokenGetter = (getter: () => Promise<string>) => {
  isTokenGetter = getter;
};

export const getIsToken = async (): Promise<string> => {
  if (!isTokenGetter) throw new Error('IS token getter not initialized');
  return isTokenGetter();
};
